import React, {useState, useEffect} from 'react';
import iconClose from '../icon-close.png';
import { useContext } from 'react';
import { MovieContext } from '../Context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import Aos from 'aos';
import 'aos/dist/aos.css';

const IMG_URL = 'https://image.tmdb.org/t/p/w500';

const MovieList = () => {

    const [videoID, setVideoID] = useState([]);
    const [isActive, setActive] = useState(false);
    
    const {API_KEY} = useContext(MovieContext);
    const {movies} = useContext(MovieContext);
    const {movieURL} = useContext(MovieContext);
    const {getMovies} = useContext(MovieContext);
    let {currentPage} = useContext(MovieContext);
    const {setCurrentPage} = useContext(MovieContext);

    useEffect(() => {
        Aos.init();
    }, [])

    useEffect(() => {
        getMovies(movieURL);
    }, []);

    useEffect(() => {
        document.addEventListener('keydown', getKeyCode, true)
    }, [isActive, videoID])

    const toggleClass = () => {
        setActive(!isActive);
    };

    const getKeyCode = (e) => {

        if(e.key === 'Escape'){
            closeOverlay();
        }
    }

    function closeOverlay(){
        setActive(!isActive);
        setVideoID(null);
    }

    function playTrailer(e){
        e.preventDefault();
        const vidID = e.target.getAttribute('data-video-id');

        fetch(`http://api.themoviedb.org/3/movie/${vidID}/videos?${API_KEY}&append_to_response=videos`).then(res => res.json()).then(data => {
            const officialTrailer = data.results.find(vid => vid.type === "Trailer").key;
            
            if(officialTrailer !== undefined){
                setVideoID(officialTrailer);
                toggleClass();
            }
            
            
        });
        
        return videoID;
    }

    function pageNext(){
        setCurrentPage(currentPage++);
        getMovies(movieURL+'&page='+currentPage);
        Aos.refreshHard();
        return currentPage;
    }

    function pagePrev(){
        if(currentPage <= 0){
            setCurrentPage(currentPage++);
            Aos.refreshHard();
            return currentPage;
        }else{
            setCurrentPage(currentPage--);
            getMovies(movieURL+'&page='+currentPage);
            Aos.refreshHard();
            return currentPage;
        }
    }

    let delay = 50;

    const movieList = movies.map((movie) => {
        if(movie.poster_path)
        delay+=50;
        return <li key={movie.id} data-aos='fade-up' data-aos-delay={delay}>
        <div className="movie-img">
            <img src={IMG_URL + movie.poster_path} alt=""/>
        </div>
        <div className="movie-details">
            <h3>{movie.title ? movie.title : movie.name}</h3>
            <h4>({movie.release_date ? movie.release_date.substr(0, 4) : movie.first_air_date ? movie.first_air_date.substr(0, 4) : 'N/A'})</h4>
            <span className="movie-rating">
            <svg width="15" height="15" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#f5c518" role="presentation"><path d="M12 20.1l5.82 3.682c1.066.675 2.37-.322 2.09-1.584l-1.543-6.926 5.146-4.667c.94-.85.435-2.465-.799-2.567l-6.773-.602L13.29.89a1.38 1.38 0 0 0-2.581 0l-2.65 6.53-6.774.602C.052 8.126-.453 9.74.486 10.59l5.147 4.666-1.542 6.926c-.28 1.262 1.023 2.26 2.09 1.585L12 20.099z"></path></svg>
            <strong>{movie.vote_average.toFixed(1)}</strong>
            </span>
            <p>{movie.overview}</p>
            <form onSubmit={playTrailer} data-video-id={movie.id}>
                <button className='play-trailer' type="submit">Play Trailer</button>
            </form>
        </div>
    </li>
    });
    

    return (
    <>
    <div id='overlay' className={isActive ? 'active': null}>
        <div className='icon-close' onClick={closeOverlay}><img width='64' height='64' src={iconClose}  alt='close' /></div>
        <div className='video-wrapper'>
            <iframe src={`https://www.youtube.com/embed/` + videoID + `?autoplay=1`}  title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
        </div>
    </div>
    <ul className="movie-list">
         {movieList}
    </ul>
    <div className='movie-nav'>
        <span className={currentPage <=1  ? 'hidden' : 'nav prev'} onClick={pagePrev}><FontAwesomeIcon icon={faAngleLeft} /></span>
        <span className='nav next' onClick={pageNext}><FontAwesomeIcon icon={faAngleRight} /></span>
    </div> 
    </> 
    )
}

export default MovieList;